
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function TreatmentOrder() {
  const heading = useFadeIn({ direction: 'up' });
  const items = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-32 md:py-40 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto space-y-16">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide text-center font-serif">
            矯正治療とホワイトニング
          </h2>
        </div>
        
        <div ref={items.ref} style={items.style} className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          <div className="flex flex-col items-center text-center space-y-6 flex-1">
            <div className="w-20 h-20 md:w-20 md:h-20 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/2ad7edb82ca820d4d476f65292fbeade.png"
                alt="line smile"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="space-y-3">
              <h3 className="text-lg font-normal text-gray-900 font-serif">マウスピース矯正</h3>
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                機能と見た目を整える
              </p>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <i className="ri-add-line text-2xl text-gray-400 hidden md:block"></i>
            <i className="ri-add-line text-2xl text-gray-400 md:hidden"></i>
          </div>
          
          <div className="flex flex-col items-center text-center space-y-6 flex-1">
            <div className="w-20 h-20 md:w-20 md:h-20 flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/d2c81e1e5b74ba1c9bf43469ef07bc8c.png" 
                alt="ホワイトニング" 
                className="w-full h-full object-contain"
              />
            </div>
            <div className="space-y-3">
              <h3 className="text-lg font-normal text-gray-900 font-serif">ホワイトニング</h3>
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                専門的知識で矯正と同時施術が可能に
              </p>
            </div>
          </div>
          
          <div className="flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-400 hidden md:block"></i>
            <i className="ri-arrow-down-line text-2xl text-gray-400 md:hidden"></i>
          </div>
          
          <div className="flex flex-col items-center text-center space-y-6 flex-1">
            <div className="w-20 h-20 md:w-20 md:h-20 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/961ffa3fa8ae35e6f3c4b613fac892e4.png"
                alt="補綴（ジルコニア）"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="space-y-3">
              <h3 className="text-lg font-normal text-gray-900 font-serif">補綴（ジルコニア）</h3>
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                最小限の介入でより綺麗に
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
